import { useContext } from 'react';

import { BuildContext } from '../providers';

export const useBuildContext = () => {
    const context = useContext(BuildContext);

    if (context === undefined || context === null) {
        throw new Error('useBuildContext must be used within a BuildContext');
    }

    return {
        ...context,
    };
};
